import React from 'react';
import PropTypes from 'prop-types';

export const ModalInfo = ({ children }) => {
  return <div className="subscription-modal__info">{React.Children.map(children, child => child)}</div>;
};

ModalInfo.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])),
    PropTypes.string,
  ]).isRequired,
};
